// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3SXQP","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2G343","obliqueLine":"membershipbadge_obliqueLine__1aSbA"};